export default __webpack_public_path__ + "static/media/ic_complete.c06c9cb5.svg";